import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Storage } from '@ionic/storage-angular';
import { AlertController, LoadingController, MenuController, NavController, NavParams, Platform, PopoverController, ToastController, } from '@ionic/angular';
import { GlobalPage } from '../global/global.page';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import BackgroundGeolocation from 'cordova-background-geolocation-lt';
import { UserdetailPage } from 'app/userdetail/userdetail.page';
import { GeolocationService } from 'app/services/geolocation.service';
@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit {
  site;
  gps: any = [];

  constructor(
    private popoverController: PopoverController, public global: GlobalPage, public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController,
    private alertCtrl: AlertController, public viewCtrl: NavController,
    private device: Device,
    //private backgroundGeolocation: BackgroundGeolocation, 
    public platform: Platform,
    public user: UserdetailPage,
    public http: HttpClient, public toastCtrl: ToastController, public storage: Storage,
    //private sqlite: SQLite
    public router: Router, public menu: MenuController,
    public geolocationService: GeolocationService
  ) { }

  ngOnInit() {
    // this.siteInfo = this.navParams.get('site');
    // console.log(this.site);
  }
  changedate() {
    this.router.navigate(['changedate']);
    this.popoverController.dismiss();
  }
  refresh() {

    this.storage.remove("OfflineDate");
    this.router.navigate(['dashboard']);
    this.popoverController.dismiss();

  }
  async changeOffline() {
    if (!this.global.offline) {
      this.global.isOfflineChangeByUser = false;
      if (!this.global.isOffline) {
        this.storage.set("online", "yes");
        //  this.selectsqlroute();
        this.global.refresh = true;
        (await this.toastCtrl.create({
          message: 'You are online !',
          duration: 3000,
        })).present();
      }
      else {
        this.global.refresh = false;
        this.global.offline = true;
        this.global.isOfflineChangeByUser = false;
        (await this.toastCtrl.create({
          message: 'No internet connection !',
          duration: 3000,
        })).present();
      }
    }

    else {
      this.global.refresh = false;
      this.global.isOfflineChangeByUser = true;
      (await this.toastCtrl.create({
        message: 'You are offline !',
        duration: 3000,
      })).present();
    }
    this.router.navigate(['dashboard']);
    this.popoverController.dismiss();
  }
  async logout() {
    //Need To Remove
    ;
    this.global.logout = true;
    let loading = this.loadingCtrl.create({
      message: "Logging out..."
    });
    let alert = this.alertCtrl.create({
      header: "Do you want to Logout?",
      // cssClass: "buttonCssa",
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            this.global.logout = false;
          }
        },
        {
          text: "Yes",
          handler: async () => {
            this.storage.remove("OfflineDate");
            this.geolocationService.stopGeoLocation();
            (await loading).present();
            //Need To Remove
            this.menu.enable(false, 'custom');
            this.router.navigate(['login']);
            this.popoverController.dismiss();
            if (!this.global.offline) {
              if (this.platform.is("android")) {
                this.gps = {
                  driverId: this.global.employee_ID,
                  latitude: "",
                  longitude: "",
                  deviceNbr: this.device.uuid,
                  deviceSerialNumber: this.device.serial,
                  driverName: this.global.driverName,
                  // timezone: '',
                  // timestamp: ''
                }
              }
              else if (this.platform.is("ios")) {
                this.gps = {
                  driverId: this.global.employee_ID,
                  latitude: "",
                  longitude: "",
                  deviceNbr: this.device.uuid,
                  deviceSerialNumber: this.device.uuid,
                  driverName: this.global.driverName,
                  // timezone: '',
                  // timestamp: ''
                }

              }
              else {
                this.storage.remove("loginAuth").then((val1) => {

                  this.storage.get("RouteSelected").then(async (val) => {
                    if (val) {
                      this.storage.get("CurrentDate").then((val2) => {
                        if (val2 != new Date().getDate()) {
                          this.storage.remove("RouteSelected");
                        }
                      })
                      this.router.navigate(['alt-login']);
                      this.global.agencyId = this.global.globalheaderTimeZone = '';
                      this.global.authtoken = '';
                      (await loading).dismiss();
                    }
                    else {
                      this.router.navigate(['login']);
                      this.global.agencyId = this.global.globalheaderTimeZone = '';
                      this.global.authtoken = '';
                      (await loading).dismiss();
                    }
                  })
                })
              }
              this.gps = JSON.stringify(this.gps)
              const httpOptions = {
                headers: new HttpHeaders({
                  "Content-Type": "application/json",
                })
              };
              // this.popoverController.dismiss();
              (await loading).dismiss();
              if (this.device.uuid != null) {
                let url = "api/NearbyVehicle/InsertNearByVehicleDetails";
                this.http.post(url, this.gps, httpOptions).subscribe(
                  (data: any) => {

                    // this.sqlite.deleteDatabase({ name: 'data.db', location: 'default'})

                    this.user.devicepushRemove()
                    this.storage.remove("loginAuth").then((val1) => {
                      BackgroundGeolocation.stop();
                      // if (this.platform.is("ios")) {
                      //   this.backgroundGeolocation.finish();
                      // }
                      this.storage.get("RouteSelected").then(async (val) => {
                        if (val) {
                          this.storage.get("CurrentDate").then((val2) => {
                            if (val2 != new Date().getDate()) {
                              this.storage.remove("RouteSelected");
                            }
                          })
                          this.router.navigate(['alt-login']);
                          this.global.agencyId = this.global.globalheaderTimeZone = '';
                          this.global.authtoken = '';
                          (await loading).dismiss();
                        }
                        else {
                          this.router.navigate(['login']);
                          this.global.agencyId = this.global.globalheaderTimeZone = '';
                          this.global.authtoken = '';
                          (await loading).dismiss();
                        }
                      })
                    })
                  }
                  ,
                  async err => {
                    (await loading).dismiss()
                  }
                );
              }
              else {
                this.storage.remove("loginAuth").then((val1) => {
                  this.storage.get("RouteSelected").then(async (val) => {
                    if (val) {
                      this.storage.get("CurrentDate").then((val2) => {
                        if (val2 != new Date().getDate()) {
                          this.storage.remove("RouteSelected");
                        }
                      })
                      this.router.navigate(['alt-login']);
                      this.global.agencyId = this.global.globalheaderTimeZone = '';
                      this.global.authtoken = '';
                      (await loading).dismiss()
                    }
                    else {
                      this.router.navigate(['login']);
                      this.global.agencyId = this.global.globalheaderTimeZone = '';
                      this.global.authtoken = '';
                      (await loading).dismiss()
                    }
                  })
                })
              }
            }
            else {
              this.storage.remove("loginAuth").then((val1) => {
                this.storage.get("RouteSelected").then(async (val) => {
                  if (val) {
                    this.storage.get("CurrentDate").then((val2) => {
                      if (val2 != new Date().getDate()) {
                        this.storage.remove("RouteSelected");
                      }
                    })
                    this.router.navigate(['alt-login']);
                    this.global.agencyId = this.global.globalheaderTimeZone = '';
                    this.global.authtoken = '';
                    (await loading).dismiss()
                  }
                  else {
                    this.router.navigate(['login']);
                    this.global.agencyId = this.global.globalheaderTimeZone = '';
                    this.global.authtoken = '';
                    (await loading).dismiss()
                  }

                })
              })
            }
          }
        }
      ],
      backdropDismiss: false
    });

    async err => {
      // console.log(err);
      (await loading).dismiss();
    };
    (await alert).present();
  }
  eventFromPopover() {
    this.popoverController.dismiss('edupala.com');
  }
}